import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import CustomPaginate from '../../../../components/PaginateComponent';
import ToggleDropdown from '../../../../components/ToogleDropdown';
import Pencil from '../../../../SVG/Pencil';
import Archive from '../../../../SVG/Archive';
import Blocked from '../../../../SVG/Blocked';
import Active from '../../../../SVG/Active';
import CornerUpRight from '../../../../SVG/CornerUpRight';
import DecomissionReason from '../../../../SVG/DecomissionReason';
import React, {useState} from 'react';
import {useTranslation} from '../../../../hooks/useTranslation';
const EquipmentDecommissionedTab = ({
  equipmentData,
  setCurrentId,
  currentId,
  handlePageClick,
  currentPage,
  handleTransfer,
  handleUnAssign,
  handleActivate,
  handleArchive,
  handleDecommission,
}) => {
  const {t} = useTranslation();
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const navigate = useNavigate();
  const enabledUser =
    userInfo?.is_global ||
    userInfo?.is_corporate ||
    userInfo?.is_regional_corporate ||
    userInfo?.is_admin;

    return (
      <div className='equipment__box'>
      <table className='equipment__table'>
        <thead className='equipment__table-head'>
          <tr>
            <th>{t('equipmentTable.headers.type')}</th>
            <th>{t('equipmentTable.headers.id')}</th>
            <th>{t('equipmentTable.headers.fuelType')}</th>
            <th>{t('equipmentTable.headers.facility')}</th>
            <th>{t('equipmentTable.headers.nfc')}</th>
              <th>{t('equipmentTable.headers.hoses')}</th>
            <th></th>
          </tr>
        </thead>
        <tbody
          className={`equipment__table-body ${!equipmentData?.data?.length ? 'empty' : ''}`}
        >
          {equipmentData?.data?.length ? (
            equipmentData?.data
              ?.filter(el => el?.type?.id !== 44)
              ?.map((equipment, index) => (
                <React.Fragment key={equipment?.id}>
                  <tr key={equipment?.id} className='equipment__table-row'
                    style={{
                      borderBottom: equipment?.decommission_reason ? 'none' : '1px solid #E9EAEB',
                    }}
                  >
                    <td
                      style={{
                        paddingBottom: equipment?.decommission_reason ? '0px' : '12px',
                      }}
                    >
          <p className='equipment__table-subtitle'>{equipment?.type?.title}</p>
        </td>
                    <td
                      style={{
                        paddingBottom: equipment?.decommission_reason ? '0px' : '12px',
                      }}
                    >
          <p className='equipment__table-subtitle'>{equipment?.title}</p>
        </td>
        <td
          style={{
            paddingBottom: equipment?.decommission_reason ? '0px' : '12px',
          }}
        >
          <p className='equipment__table-subtitle'>
            {equipment?.fuel_type?.name ? equipment?.fuel_type?.name : '---'}
          </p>
        </td>
        <td
          style={{
            paddingBottom: equipment?.decommission_reason ? '0px' : '12px',
          }}
        >
          <p className='equipment__table-subtitle'>
            {equipment?.facility?.name}
          </p>
        </td>

        <td className='s'
          style={{
            paddingBottom: equipment?.decommission_reason ? '0px' : '12px',
          }}
        >
          <p className='equipment__table-title'>NFC</p>
          {equipment?.beacon_address ? (
            <p className='equipment__table-subtitle'>
              <img src='/assets/icons/nfc-active.png' alt='icon' />
              <img
                src='/assets/icons/beacon-address.svg'
                onClick={() => {handleUnAssign(equipment)}}                alt='icon'
              />
            </p>
          ) : (
            <p className='equipment__table-subtitle'>
              <img src='/assets/icons/nfc-inactive.png' alt='icon' />
            </p>
          )}
        </td>

        <td
          style={{
            paddingBottom: equipment?.decommission_reason ? '0px' : '12px',
          }}
        >
          <ToggleDropdown
            index={index}
            itemId={equipment?.id}
            selectedItem={currentId}
            setSelectedItem={setCurrentId}
            showNdxId={userInfo?.is_global}
                      >
                        {
            userInfo?.is_corporate && !userInfo?.is_regional_corporate && equipment?.can_be_transferred && (
              <div className='equipment__table-btn blue' onClick={() => handleTransfer(equipment)}>
              <CornerUpRight color={'#999999'} />
              <p>{t('equipmentTable.actions.transfer')}</p>
            </div>
              )
            }
            <div
              className='equipment__table-btn blue'
              onClick={() => {
                navigate(`/equipment/edit/${equipment?.id}`, {
                  state: {equipment},
                });
              }}
            >
              <Pencil color={'#999999'}/>
              {t('equipmentTable.actions.edit')}
            </div>
            {!equipment?.is_active && enabledUser ? (
              <div
                className='equipment__table-btn red'
                onClick={() => {
                  handleArchive(equipment);
                }}
              >
                <Archive color={'#999999'}/>
                {t('equipmentTable.actions.archive')}
              </div>
            ) : null}

            {equipment?.is_active ? (
              <div
                className='equipment__table-btn decom red'
                onClick={() => {
                  handleDecommission(equipment);
                }}
              >
                <Blocked color={'#999999'}/>
                {t('equipmentTable.actions.decommission')}
              </div>
            ) : (
              <div
                className='equipment__table-btn decom green'
                onClick={() => {
                  handleActivate(equipment);
                }}
              >
                <Active color={'#999999'}/>
                {t('equipmentTable.actions.activate')}
              </div>
            )}
          </ToggleDropdown>
        </td>
      </tr>
      {/* Reason Message Row - Full width under the main row */}
      {equipment?.decommission_reason && (
        <tr className='equipment__reason-row'>
          <td colSpan="12" className='equipment__reason-cell'>
            <div className='equipment__reason-message'>
              <DecomissionReason />
                          <span>{equipment?.decommission_reason} <b>{equipment?.status_updated_by ? ` - Decommissioned by ${equipment?.status_updated_by?.name}` : ''} {equipment?.status_updated_at && equipment?.status_updated_by?.name ? ` on ${equipment?.status_updated_at}` : ''}</b></span>
            </div>
          </td>
        </tr>
      )}
    </React.Fragment>
              ))
          ) : (
            <tr className='equipment__table-row empty-row'>
              <td colSpan="9" className='equipment__table-empty'>
                <div className='equipment__table-empty-content'>
                  <img src='/assets/empty-list.png' alt='empty' />
                  <p>{t('equipmentTable.messages.noData')}</p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <CustomPaginate
        pageCount={equipmentData?.pages}
        handlePageClick={handlePageClick}
        currentPage={currentPage}
      />
    </div>
  )
};

export default EquipmentDecommissionedTab;
